module.exports = __webpack_public_path__ + "assets/30d9b924b69f283206afc28aea88aa2b.png";